<template>
<div class="box">


  <div class="end">
    <HistoryOrderModal
      :visible="historyOrderModal"
      :item="{ personId: user.id }"
      @cancel="historyOrderModal = false"
      @ok="onHistoryOrderOk"
    />
    <!--==============工厂信息==================-->
    <div class="page-gg-form">
      <!-- <div class="page-hd" /> -->
      <span class="span-gongTital"
        >{{ $tc('lang.menuGoodsSpace.Vendor_Information') }}</span
      >
      <a-form :form="forms" @submit="handleSubmit" class="page-gdFrom">
        <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Name')">
          <a-input
            :placeholder="$tc('lang.menuGoodsSpace.Factory_Cn')"
            class="batton-style"
            v-decorator="[
              'orderFactoryname',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.menuGoodsSpace.Factory_Cn'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label="$tc('lang.menuGoodsSpace.Region')"
          v-if="$i18n.locale === 'zh-CN'"
        >
          <a-cascader
            :options="preCiy"
            :placeholder="$tc('lang.menuGoodsSpace.Please_fill_in_the_region')"
            class="batton-style"
            @change="onAreaChange"
            expand-trigger="hover"
            v-decorator="[
              'orderFactoryarea',
              {
                rules: [
                  {
                    required: true,
                    message: $tc(
                      'lang.menuGoodsSpace.Please_fill_in_the_region',
                    ),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Address')">
          <a-input
            :placeholder="$tc('lang.menuGoodsSpace.Vendor_Address_text')"
            class="batton-style"
            v-decorator="[
              'orderFactoryaddress',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.menuGoodsSpace.Vendor_Address_text'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <div class="page-form-oneself">
          <a-form-item :label="$tc('lang.menuGoodsSpace.Contact_Name')">
            <a-input
              :placeholder="$tc('lang.menuGoodsSpace.Please_contact_name')"
              class="batton-style"
              v-decorator="['orderFactoryperson']"
            />
          </a-form-item>
          <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
            <a-input
              :placeholder="$tc('lang.menuGoodsSpace.Please_Telephone_number')"
              class="batton-style"
              v-decorator="['orderFactoryfixedtel']"
            />
          </a-form-item>
        </div>
        <div class="page-form-oneself">
          <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
            <div class="page-mobile-input">
              <a-input
                :placeholder="$tc('lang.menuGoodsSpace.Please_mobile_number')"
                v-decorator="[
                  'orderFactorytel',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc(
                          'lang.menuGoodsSpace.Please_mobile_number',
                        ),
                      },
                      // {
                      //   validator: $checking.validateMobilePhone,
                      // },
                    ],
                  },
                ]"
              />
            </div>
          </a-form-item>
          <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
            <a-input
              :placeholder="$tc('lang.menuGoodsSpace.Please_E_mail_Add')"
              class="batton-style"
              v-decorator="['orderFactoryemail']"
            />
          </a-form-item>
        </div>
      </a-form>
    </div>
    <!--==============我的信息==================-->
    <div class="page-gg-form">
      <span class="span-gongTital"
        >{{
          $tc('lang.menuGoodsSpace.Company_Profile')
        }}&nbsp;&nbsp;&nbsp;</span
      >
      <!-- <div class="page-hd" /> -->
      <a-form :form="forms" @submit="handleSubmit" class="page-gdFrom">
        <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Name')">
          <a-input
            :placeholder="$tc('lang.menuGoodsSpace.Please_company_Name')"
            v-decorator="[
              'orderTrustcompany',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.menuGoodsSpace.Please_company_Name'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Address')">
          <a-input
            :placeholder="$tc('lang.menuGoodsSpace.Please_company_Address')"
            v-decorator="['orderTrustaddress']"
          />
        </a-form-item>
        <div class="page-form-oneself">
          <a-form-item :label="$tc('lang.menuGoodsSpace.Contact_Name')">
            <a-input
              :placeholder="$tc('lang.menuGoodsSpace.Please_contact_name')"
              v-decorator="['orderTrustperson']"
            />
          </a-form-item>
          <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
            <a-input
              :placeholder="$tc('lang.menuGoodsSpace.Please_Telephone_number')"
              v-decorator="['orderTrustfixedtel']"
            />
          </a-form-item>
        </div>
        <div class="page-form-oneself">
          <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
            <div class="page-mobile-input">
              <a-input
                :placeholder="$tc('lang.menuGoodsSpace.Please_mobile_number')"
                v-decorator="[
                  'orderTrusttel',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc(
                          'lang.menuGoodsSpace.Please_mobile_number',
                        ),
                      },
                      // {
                      //   validator: $checking.validateMobilePhone,
                      // },
                    ],
                  },
                ]"
              />
            </div>
          </a-form-item>
          <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
            <a-input
              :placeholder="$tc('lang.menuGoodsSpace.Please_E_mail_Add')"
              v-decorator="['orderTrustemail']"
            />
          </a-form-item>
        </div>
      </a-form>
    </div>
    <!--==============产品信息===================-->
    <div class="page-gg-form">
      <span class="span-gongTital"
        >{{
          $tc('lang.menuGoodsSpace.Product_Details')
        }}&nbsp;&nbsp;&nbsp;</span
      >
      <!-- <div class="page-hd" /> -->
      <div class="page-gdFrom">
        <div style="margin: 0 0 auto 0;text-align: right;"> 
          <a-button type="primary" @click="add"><a-icon type="plus-circle" />新增</a-button></div>  
        <div class="page-tabGd" v-for="pane in panes" :key="pane.key" >
          <div style="margin: 20px 0px 0 auto;width: 40px;" v-if="pane.key>1" @click='remove(pane.key)'><a-icon style="font-size: 20px;color: #c00;" type="delete" /></div>
          <!-- <a-tabs
            v-model="activeKey"
            type="editable-card"
            @edit="onEdit"
            @submit="handleSubmit"
          >
            <a-tab-pane
              v-for="pane in panes"
              :tab="pane.title"
              :key="pane.key"
              change=""
              :tableCallback="pane.closable"
              :closable="pane.closable"
            > -->
            <div class="card">
              <a-form :form="foProduct['form' + pane.key]">
                <div class="page-form-oneself">
                <a-form-item :label="$tc('lang.menuGoodsSpace.Product_Name')" style="width: 50%;">
                  <a-input
                    :placeholder="
                      $tc('lang.menuGoodsSpace.Please_product_name')
                    "
                    v-decorator="[
                      'productName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $tc(
                              'lang.menuGoodsSpace.Please_product_name',
                            ),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
                <a-form-item
                  :label="$tc('lang.menuGoodsSpace.Item_Number_Style')"
                   style="width: 50%;"
                >
                  <a-input
                    :placeholder="
                      $tc('lang.menuGoodsSpace.Please_product_style')
                    "
                    v-decorator="[
                      'productModelid',
                      {
                        rules: [
                          {
                            required: true,
                            message: $tc(
                              'lang.menuGoodsSpace.Please_product_style',
                            ),
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="page-card">
                <a-form-item 
                style="width: 50%;"
                :label="$tc('lang.menuGoodsSpace.Order_Number')" >
                  <a-input
                    :placeholder="
                      $tc('lang.menuGoodsSpace.Please_order_number')
                    "
                    v-decorator="['orderId']"
                  />
                </a-form-item>
              <!-- </div> -->
                <!-- <div class="page-card"> -->
                <div class="page-danwei">
                  <a-form-item 
                  style="width: 50%;"
                  :label="$tc('lang.menuGoodsSpace.Quantity')">
                    <a-input-number
                      :min="1"
                      @change="onNumberChange"
                      v-decorator="[
                        'productCount',
                        {
                          initialValue: productCount,
                          rules: [
                            {
                              required: true,
                              message: $tc('lang.menuGoodsSpace.Unit'),
                            },
                          ],
                        },
                      ]"
                    />
                    <div class="page-unitName">
                      <a-select
                        @change="handleChange"
                        v-decorator="[
                          'productUnit',
                          {
                            initialValue: $tc('lang.menuGoodsSpace.pcs'),
                          },
                        ]"
                      >
                        <a-select-option
                          :value="$tc('lang.menuGoodsSpace.pcs')"
                          >{{ $tc('lang.menuGoodsSpace.pcs') }}</a-select-option
                        >
                        <a-select-option
                          :value="$tc('lang.menuGoodsSpace.pair')"
                          >{{
                            $tc('lang.menuGoodsSpace.pair')
                          }}</a-select-option
                        >
                        <a-select-option
                          :value="$tc('lang.menuGoodsSpace.yard')"
                          >{{
                            $tc('lang.menuGoodsSpace.yard')
                          }}</a-select-option
                        >
                        <a-select-option
                          :value="$tc('lang.menuGoodsSpace.set')"
                          >{{ $tc('lang.menuGoodsSpace.set') }}</a-select-option
                        >
                        <a-select-option
                          :value="$tc('lang.menuGoodsSpace.ctn')"
                          >{{ $tc('lang.menuGoodsSpace.ctn') }}</a-select-option
                        >
                        <a-select-option
                          :value="$tc('lang.menuGoodsSpace.Other')"
                          >{{
                            $tc('lang.menuGoodsSpace.Other')
                          }}</a-select-option
                        >
                      </a-select>
                    </div>
                  </a-form-item>

                </div>
              </div>
              </a-form>
            </div>
        </div>
      </div>
    </div>
    <!--===============AQL======================-->
    <div class="page-gg-form">
      <span class="span-gongTital">AQL&nbsp;&nbsp;&nbsp;</span>
      <!-- <div class="page-hd" /> -->
      <a-form :form="forms" @submit="handleSubmit" class="page-gdFrom aql">
        <a-form-item
          :label="$tc('lang.menuGoodsSpace.Inspection_standard')"
          style="text-align: left"
        >
          <!-- <span>ANSI/ASQ Z1.4 Single Sampling Plan</span> -->
          <span>ASTM D5430 Four Point System</span>
          <span>{{ $tc('lang.menuGoodsSpace.point_system') }}</span>
        </a-form-item>
        <a-form-item label="评判标准*" style="text-align: left">
          <!-- <span>ASTM D5430 Four Point System</span>
          <span>{{ $tc('lang.menuGoodsSpace.point_system') }}</span> -->
          <a-radio-group @change="onChange" v-model="Inspection_Level">
            <a-radio :style="radioStyle" :value="1"
              >出货数量开平方根*10</a-radio
            >
            <a-radio :style="radioStyle" :value="2">
              <a-input-number
                :min="1"
                style="width: 100px"
                type="number"
                :disabled="Inspection_Level != 2"
                v-model="orderFabrileveltwo"
              />&nbsp; %出货数量
            </a-radio>
            <a-radio :style="radioStyle" :value="3">
              固定数量&nbsp;<a-input-number
                :min="1"
                style="width: 100px"
                type="number"
                :disabled="Inspection_Level != 3"
                v-model="orderFabrilevelthree"
              />&nbsp;码
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <div class="page-namm">
          <a-form-item
            label="可接受质量限制"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <div style="width: 360px; text-align: left">
              <div class="page-number-num">
                <span
                  >{{ $tc('lang.menuGoodsSpace.Max_penalty_points_text') }}:
                </span>
                <a-input-number
                  :min="24"
                  v-decorator="[
                    'productNumber',
                    {
                      initialValue: productNumber,
                      rules: [
                        {
                          required: true,
                          message: '请填写每100平方码平均罚分!',
                        },
                      ],
                    },
                  ]"
                />
              </div>
              <div class="page-number-num">
                <span
                  >{{ $tc('lang.menuGoodsSpace.Max_penalty_points') }}：</span
                >
                <a-input-number
                  :min="14"
                  v-decorator="[
                    'productNumber1',
                    {
                      initialValue: productNumber1,
                      rules: [
                        {
                          required: true,
                          message: '请填写每100平方码1分疵点罚分!',
                        },
                      ],
                    },
                  ]"
                />
              </div>
            </div>

            <div style="width: 550px; text-align: left">
              <span style="color: rgb(195, 195, 195)"
                >{{ $tc('lang.menuGoodsSpace.It_will_be_judged') }}
              </span>
            </div>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <!--===============验货时间======================-->
    <div class="page-gg-form" style="display: flex">
      <div style="width: 50%">
      <span class="span-gongTital"
        >{{
          $tc('lang.menuGoodsSpace.Inspection_Date')
        }}&nbsp;&nbsp;&nbsp;</span
      >
      <!-- <div class="page-hd" /> -->
      <a-form :form="forms" @submit="handleSubmit" class="page-gdFrom-One">
        <div>
          <a-form-item>
            <div class="page-pick-te">
            <a-date-picker
              :disabledDate="disabledDate"
              @change="onDateChange"
              :placeholder="$tc('lang.menuGoodsSpace.Select_date')"
              v-decorator="[
                'orderServicedate',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.menuGoodsSpace.Select_date'),
                    },
                  ],
                },
              ]"
            />
            </div>
          </a-form-item>
        </div>
        <span style="color: rgba(195, 195, 195, 1); margin-right: 10%">
          {{ $tc('lang.menuGoodsSpace.Please_select_date') }}
        </span>
      </a-form>
      </div>
    <!-- </div> -->
    <!--===============检验资料======================-->
    <!-- <div class="page-gg-form"> -->
      <div style="width: 50%">
      <span class="span-gongTital"
        >{{
          $tc('lang.menuGoodsSpace.inspection_files')
        }}&nbsp;&nbsp;&nbsp;</span
      >
      <!-- <div class="page-hd" /> -->
      <a-form :form="forms" @submit="handleSubmit" class="page-gdFrom-One">
        <a-form-item style="text-align: left; width: 100%">
          <div class="page-inpt-te">
            <a-upload
              :data="upled"
              :action="config.urlImg + urlName"
              :fileList="fileList"
              @change="handleChangeUpload"
              :multiple="true"
            >
              <a-button>
                <a-icon type="upload" /> {{ $tc('lang.menuGoodsSpace.upload') }}
              </a-button>
            </a-upload>
          </div>
          <span style="color: rgba(195, 195, 195, 1)">
            {{ $tc('lang.menuGoodsSpace.upload_text') }}
          </span>
        </a-form-item>
      </a-form>
      </div>
    </div>
    <!--===============特别注意点======================-->
    <div class="page-gg-form">
      <span class="span-gongTital"
        >{{
          $tc('lang.menuGoodsSpace.Special_Attention')
        }}&nbsp;&nbsp;&nbsp;</span
      >
      <!-- <div class="page-hd" /> -->
      <a-form :form="forms" @submit="handleSubmit" class="page-gdFrom-One">
        <a-form-item>
          <div class="page-inpt-te">
            <a-textarea
              :placeholder="$tc('lang.menuGoodsSpace.Please_special_attention')"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-decorator="['orderRequire']"
            />
          </div>
        </a-form-item>
      </a-form>
    </div>
  
    <start-from ref="startFrom" />
  </div>
  <div class="page-gg-form-subimt">
      <form :form="forms" @submit="handleSubmit" class="page-gdFrom-One">
        <a-form-item :wrapper-col="{ span: 1, offset: 12 }">
          <div class="page-gdSubmit">

            <a-button type="primary" html-type="submit">
              {{ $tc('lang.menuGoodsSpace.Generating_orders') }}
            </a-button>
            <a-button type="primary" @click="handleSubmit(10)" >  {{ $tc('lang.menuGoodsSpace.Add_to_draft') }}</a-button>
            <a-button type="primary"   @click="historyOrderModal = !historyOrderModal">
              {{ $tc('lang.menuGoodsSpace.history_orders') }}
            </a-button>
          </div>
        </a-form-item>
      </form>
    </div>
</div>
</template>
<!--面料-->
<script>
import AFormItem from 'ant-design-vue/es/form/FormItem';
import startFrom from './startFrom';
import HistoryOrderModal from '../../../components/HistoryOrderModal.vue';
import moment from 'moment'; 
export default {
  name: 'end',
  components: {
    AFormItem,
    'start-from': startFrom,
    HistoryOrderModal,
  },
  data() {
    //表格
    const panes = [
      {
        title: this.$tc('lang.menuGoodsSpace.product') + '1',
        content: 'Content of Tab 1',
        key: '1',
        closable: false,
      },
    ];
    return {
      radioStyle: {
        textAlign: 'left',
        display: 'block',
        height: '40px',
        lineHeight: '40px',
      },
      // lonBtnType: true,
      // checkOutType: 'start',
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      forms: this.$form.createForm(this),
      chanpinList: [],
      valuuu1: '',
      /*工厂名称*/
      /*产品信息*/
      foProduct: {
        form1: this.$form.createForm(this),
      },
      // 数量
      productCount: 1,
      // 产品名称
      productName: '',
      // 款号/型号
      productModelid: '',
      // 订单号
      orderId: '',
      // 单位
      productUnit: '',
      // 联动数据
      options: [],
      // AQL
      productNumber: 24,
      productNumber1: 14,
      Inspection_Level: null,
      orderFabrileveltwo: null,
      orderFabrilevelthree: null,
      // 表格
      //danqianxuanzhong
      // activeKey: 1,
      activeKey: panes[0].key,
      panes,
      newTabIndex: 1,
      formDataList: [],
      upled: {
        mediaName: '验货',
        mediaType: '2',
        mediaDesc: 'order_annex',
      },
      //草稿箱
      orderState: '1',
      // 上传附件
      fileList: [],
      urlName: '/hzwmj/media/fileUpload',
      reload: this.reload,
      disabledDate(current) {
        console.log('current', current);
        // Can not select days before today and today
        return current && current < moment().subtract(1, 'days');
      },
      // 防止多次点击
      isClick: true,
      // 订单号
      orderIdFrom: '',
      // 用户信息
      user: {},
      historyOrderModal: false,
    };
  },
  // 数据状态处理全局
  computed: {
    // 表单提交数据语言
    orderReporttype: {
      get() {
        return this.$store.state.downOrder.orderReporttype;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          orderReporttype: value,
        });
      },
    },
    // 验货类型切换
    orderType: {
      get() {
        return this.$store.state.downOrder.orderType;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          orderType: value,
        });
      },
    },
    // form表单提交的数据
    goodsDataList: {
      get() {
        return this.$store.state.downOrder.goodsDataList;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          goodsDataList: value,
        });
      },
    },
    // 城市联动
    preCiy: {
      get() {
        return this.$store.state.downOrder.preCiy;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          preCiy: value,
        });
      },
    },
    // 验货下单返回数据
    dataOrder: {
      get() {
        return this.$store.state.downOrder.dataOrder;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          dataOrder: value,
        });
      },
    },
    // 验货订单保存草稿箱返回数据
    draftsState: {
      get() {
        console.log(
          'this.$store.state.downOrder.draftsState',
          this.$store.state.downOrder.draftsState,
        );
        return this.$store.state.downOrder.draftsState;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          draftsState: value,
        });
      },
    },
  },
  created() {
    // 查询城市联动
    this.$store.dispatch('downOrder/queryPreCiy');
    console.log(this.$route.params.id)
    //获取页面
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
    // 获取订单数据
    if (theRequest.type === '2') {
      this.dataList();
      this.orderIdFrom = theRequest.orderId;

    }
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    }
    this.handUserNum();
  },
  watch: {
    // 验货下单返回数据
    dataOrder: function (val) {
      console.log('===数据结果===', val);
      if (val === true) {
        this.form.resetFields();
        this.forms.resetFields();
        console.log('===val===', val);
        this.$refs.startFrom.out();
        this.fileList = [];
        this.panes = [
          {
            title: this.$tc('lang.menuGoodsSpace.Please_special_attention'),
            content: 'Content of Tab 1',
            key: '1',
            closable: false,
          },
        ];
        this.activeKey = this.panes[0].key;
        this.formDataList = [];
        this.foProduct = {
          form1: this.$form.createForm(this),
        };
        this.productNumber = 24;
        this.productNumber1 = 14;
        this.Inspection_Level = null;
        this.orderFabrileveltwo = null;
        this.orderFabrilevelthree = null;
        this.$router.push('/goods');
      } else {
        this.$refs.startFrom.init();
      }
    },
    // 验货订单保存草稿箱返回数据
    draftsState: function (val) {
      console.log('===数据结果===', val);
      if (val === true) {
        this.form.resetFields();
        this.forms.resetFields();
        console.log('===val===', val);
        this.$refs.startFrom.out();
        this.fileList = [];
        this.panes = [
          {
            title: this.$tc('lang.menuGoodsSpace.Please_special_attention'),
            content: 'Content of Tab 1',
            key: '1',
            closable: false,
          },
        ];
        this.activeKey = this.panes[0].key;
        this.formDataList = [];
        this.foProduct = {
          form1: this.$form.createForm(this),
        };
        
        this.$router.push('/goods');
      }
    },
  },
  methods: {
    /*表单提交*/
    handleSubmit(e) {
      event.preventDefault();
      if (e === 10) {
        // 表单提交的数据
        if (this.isClick) {
          this.isClick = false;
          this.formDataList = [];
          for (let i = 0; i < this.panes.length; i++) {
            var aa = 'form' + this.panes[i].key;
            this.foProduct[aa].validateFieldsAndScroll((err, values) => {
              //每次循环获取tabl表单数据
              if (!err) {
                this.formDataList.push(values);
              }
            });
          }
         
          console.log('==formDataList=====', this.formDataList);
          // 表单提交数据和当前阶段以及语言
          this.goodsDataList = {
            formDataList: this.formDataList,
            orderType: this.orderType,
            orderReporttype: this.orderReporttype,
            orState: e,
          };
          console.log('=====goodsDataList====', this.onFileList());
          // 获取其它全部数据
          this.forms.validateFieldsAndScroll((err, values) => {
            console.log('values', values);
            if (!err) {
              if (this.Inspection_Level == null) {
                this.$message.error('请选择评判标准');
              } else {
                if (
                  this.Inspection_Level == 2 &&
                  this.orderFabrileveltwo == null
                ) {
                  this.$message.error('请填写评判标准');
                } else if (
                  this.Inspection_Level == 3 &&
                  this.orderFabrilevelthree == null
                ) {
                  this.$message.error('请填写评判标准');
                } else {
                  this.goodsDataList = {
                    tableDataList: this.formDataList,
                    orderType: this.orderType,
                    orderReporttype: this.orderReporttype,
                    formDataMap: values,
                    fileList: this.onFileList(),
                    orState: e,
                    orderIdFrom: this.orderIdFrom,
                  };
                }
              }
            }
          });
          this.$store.dispatch('downOrder/startOrderDown', this.goodsDataList);
          console.log('this.dataOrder', this.dataOrder);
        } else {
          this.$message.error('请勿多次点击!');
          let _this = this;
          setTimeout(function () {
            // 设置延迟事件，1秒后将执行
            _this.isClick = true; // 将isClick设置为true
          }, 1000);
        }
      } else {
        this.formDataList = [];
        for (let i = 0; i < this.panes.length; i++) {
          var fromNum = 'form' + this.panes[i].key;
          this.foProduct[fromNum].validateFieldsAndScroll((err, values) => {
            //每次循环获取tabl表单数据
            if (!err) {
              this.formDataList.push(values);
            }
          });
        }
        if(this.formDataList.length==0){
          return
        }
        // console.log('==formDataList=====', this.formDataList);
        // 表单提交数据和当前阶段以及语言
        this.goodsDataList = {
          formDataList: this.formDataList,
          orderType: this.orderType,
          orderReporttype: this.orderReporttype,
          orState: e,
        };
        // console.log('=====goodsDataList====', this.onFileList());
        // 获取其它全部数据
        this.forms.validateFieldsAndScroll((err, values) => {
          values.Inspection_Level = this.Inspection_Level;
          values.orderFabrileveltwo = this.orderFabrileveltwo;
          values.orderFabrilevelthree = this.orderFabrilevelthree;
          // console.log('values', values);
          if (!err) {
            if (this.Inspection_Level == null) {
              this.$message.error('请选择评判标准');
            } else {
              if (
                this.Inspection_Level == 2 &&
                this.orderFabrileveltwo == null
              ) {
                this.$message.error('请填写评判标准');
              } else if (
                this.Inspection_Level == 3 &&
                this.orderFabrilevelthree == null
              ) {
                this.$message.error('请填写评判标准');
              } else {
                this.goodsDataList = {
                  tableDataList: this.formDataList,
                  orderType: this.orderType,
                  orderReporttype: this.orderReporttype,
                  formDataMap: values,
                  fileList: this.onFileList(),
                  orState: e,
                  orderIdFrom: this.orderIdFrom,
                };
              }
            }
          }
        });
        this.$refs.startFrom.init();
      }
    },
    onChange(e) {
      this.Inspection_Level = e.target.value;
    },
    /*handleSubmit(e) {
      event.preventDefault();
      // 表单提交的数据
      if (this.isClick) {
        this.isClick = false;
        this.formDataList = [];
        for (let i = 0; i < this.panes.length; i++) {
          var aa = 'form' + this.panes[i].key;
          this.foProduct[aa].validateFieldsAndScroll((err, values) => {
            //每次循环获取tabl表单数据
            if (!err) {
              this.formDataList.push(values);
            }
          });
        }
        // 表单提交数据和当前阶段以及语言
        this.goodsDataList = {
          formDataList: this.formDataList,
          orderType: this.orderType,
          orderReporttype: this.orderReporttype,
          orState: e,
        };
        // 获取其它全部数据
        this.forms.validateFieldsAndScroll((err, values) => {
          if (!err) {
            this.goodsDataList = {
              tableDataList: this.formDataList,
              orderType: this.orderType,
              orderReporttype: this.orderReporttype,
              formDataMap: values,
              fileList: this.onFileList(),
              orState: e,
            };
          }
        });
        this.$store.dispatch('downOrder/startOrderDown', this.goodsDataList);
        // const data = this.dataOrder;
        console.log('this.dataOrder', this.dataOrder);
        if (this.dataOrder === true) {
          this.form.resetFields();
          this.forms.resetFields();
          // this.fo = {
          //   form1: this.form.resetFields(),
          // };
          // this.$router.push('/goods/start');
          this.$router.go(0);
        }
      } else {
        this.$message.error('请勿多次点击!');
        let _this = this;
        setTimeout(function() {
          // 设置延迟事件，1秒后将执行
          _this.isClick = true; // 将isClick设置为true
        }, 1000);
      }
    },*/
    //当前下单页面填充我的信息
    handUserNum() {
      console.log('===this.user===', this.user.personCompanyname);
      setTimeout(() => {
        this.forms.setFieldsValue({
          // 我的信息
          orderTrustcompany: this.user.personCompanyname,
          orderTrustaddress: this.user.personAddress,
          orderTrustperson: this.user.personContactname,
          orderTrustfixedtel: this.user.personFixedtel,
          orderTrusttel: this.user.personMobilephone,
          orderTrustemail: this.user.personEmail,
        });
      });
    },
    // 获取订单数据
    dataList() {
      const url = window.location.href;
      const theRequest = new Object();
      // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
      if (url.indexOf('?') != -1) {
        //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
      this.loading = true;
      this.$http
        .post('/hzwmj/workorder/selectById', {
          id: theRequest.id,
        })
        .then((data) => {
          if (data != null) {
            const reastData = data.data;
            console.log('======', reastData);
            const workorder = reastData.workorder;
            this.forms.setFieldsValue({
              // 工厂信息
              orderFactoryname: workorder.orderFactoryname,
              orderFactoryarea:
                workorder.orderFactoryarea !== null
                  ? workorder.orderFactoryarea.split('/')
                  : [],
              orderFactoryaddress: workorder.orderFactoryaddress,
              orderFactoryperson: workorder.orderFactoryperson,
              orderFactoryfixedtel: workorder.orderFactoryfixedtel,
              orderFactorytel: workorder.orderFactorytel,
              orderFactoryemail: workorder.orderFactoryemail,
              // 我的信息
              orderTrustcompany: workorder.orderTrustcompany,
              orderTrustaddress: workorder.orderTrustaddress,
              orderTrustperson: workorder.orderTrustperson,
              orderTrustfixedtel: workorder.orderTrustfixedtel,
              orderTrusttel: workorder.orderTrusttel,
              orderTrustemail: workorder.orderTrustemail,
              //验货时间
              // orderServicedate: workorder.orderServicedate,
              //检验水平
              aql: workorder.orderLevel,
              //致命缺陷
              criterion: workorder.orderFataldefect,
              //严重缺陷
              serious: workorder.orderSeriousdefect,
              //轻微缺陷
              slight: workorder.orderMinordefect,
            });
            // 添加产品数据
            const products = reastData.products;
            const newFoProduct = {};
            const panes = [];
            products.forEach((item, index) => {
              const activeKey = (this.newTabIndex += index);
              panes.push({
                title: this.$tc('lang.menuGoodsSpace.product') + `${activeKey}`,
                content: 'Content of new Tab',
                key: activeKey,
              });
              this.activeKey = activeKey;
              /*添加时候添加form表单数据处理*/
              let formAs = 'form' + activeKey;
              newFoProduct[formAs] = this.$form.createForm(this);
            });
            this.foProduct = newFoProduct;
            this.panes = panes;
            console.log('==foProduct===', this.foProduct);
            setTimeout(() => {
              products.forEach((item, index) => {
                let formAs = 'form' + (index + 1);
                this.foProduct[formAs].setFieldsValue({
                  productName: item.productName,
                  productModelid: item.productModelid,
                  orderId: item.productOrderid,
                  productCount: item.productCount,
                  productUnit: item.productUnit,
                });
              });
            });
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
    // 遍历生产订单上传附件的ID
    onFileList() {
      let file = [];
      console.log('this.fileList', this.fileList);
      const fileList = this.fileList;
      if (fileList.length > 0) {
        fileList.forEach((value) => {
          file.push(value.response.data.object.id);
          console.log(value.response.data.object.id);
        });
        console.log('file', file);
        return file.join(',');
      } else {
        return '';
      }
    },
    // chunchaogao
    onchaogao(value) {
      console.log(value);
      this.handleSubmit();
    },
    /*所在区域联动*/
    onAreaChange(value) {
      console.log(value);
    },
    /*表格方法*/
    tableCallback(key) {
      console.log(key);
    },
    onEdit(targetKey, action) {
      this[action](targetKey);
    },
    add() {
      const activeKey = (this.newTabIndex += 1);
      this.panes.push({
        title: this.$tc('lang.menuGoodsSpace.product') + `${activeKey}`,
        content: 'Content of new Tab',
        key: activeKey,
      });
      // this.panes = panes;
      this.activeKey = activeKey;
      /*添加时候添加form表单数据处理*/
      let formAs = 'form' + activeKey;
      formAs in this.foProduct
        ? ''
        : (this.foProduct[formAs] = this.$form.createForm(this));
    },
    remove(targetKey) {
      let activeKey = this.activeKey;
      let lastIndex;
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      const panes = this.panes.filter((pane) => pane.key !== targetKey);
      if (lastIndex >= 0 && activeKey === targetKey) {
        activeKey = panes[lastIndex].key;
      }
      this.panes = panes;
      this.activeKey = activeKey;
      const foProduct = this.foProduct;
      var formAs = 'form' + targetKey;
      delete this.foProduct[formAs];
      this.foProduct = foProduct;
    },
    onNumberChange(value) {
      this.productNumber = value;
    },
    /*下拉*/
    handleChange(value) {
      // this.add()
      console.log(`selected ${value}`);
    },
    /*检验时间*/
    onDateChange(date, dateString) {
      console.log(date, dateString);
    },
    /*上传附件*/
    handleChangeUpload(info) {
      let fileList = [...info.fileList];
      // 从响应读取并显示文件链接
      fileList = fileList.map((file) => {
        if (file.response) {
          // 组件将file.url显示为链接
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
    },
    /**
     * 选择历史订单数据
     */
    async onHistoryOrderOk(workorder) {
      console.log('onHistoryOrderOk', workorder);
      this.forms.setFieldsValue({
        // 工厂信息
        orderFactoryname: workorder.orderFactoryname,
        orderFactoryarea:
          workorder.orderFactoryarea !== null
            ? workorder.orderFactoryarea.split('/')
            : [],
        orderFactoryaddress: workorder.orderFactoryaddress,
        orderFactoryperson: workorder.orderFactoryperson,
        orderFactoryfixedtel: workorder.orderFactoryfixedtel,
        orderFactorytel: workorder.orderFactorytel,
        orderFactoryemail: workorder.orderFactoryemail,

        orderTrustcompany:workorder.ordertrustcompany,
        orderTrustaddress:workorder.ordertrustaddress,
        orderTrustperson:workorder.ordertrustperson,
        orderTrustfixedtel:workorder.ordertrusttel,
        orderTrusttel:workorder.ordertrustfixedtel,
      });
      this.historyOrderModal = false;
    },
  },
};
</script>

<style lang="less">
@import './styles';
</style>
